import React from "react";

interface MetricCardProps {
  label: string;
  value: string | number;
}

export const ChartMetricCard = ({ label, value }: MetricCardProps) => (
  <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-white/20 rounded-md p-4 shadow-sm text-center">
    <div className="text-gray-500 dark:text-gray-300 text-sm">{label}</div>
    <div className="font-bold text-lg dark:text-white">{value}</div>
  </div>
);
